import { render, staticRenderFns } from "./InquiryTable.vue?vue&type=template&id=5bf0318c&"
import script from "./InquiryTable.vue?vue&type=script&lang=js&"
export * from "./InquiryTable.vue?vue&type=script&lang=js&"
import style0 from "./InquiryTable.vue?vue&type=style&index=0&id=5bf0318c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports